import Api from './api.js'
import ipInt from 'ip-to-int'

const api = new Api()

const ParamsService = class ParamsService {
  static async getIpAddress () {
    let url = 'https://service.next.tourismusnetz.com'
    try {
      const response = await api.get(url)
      const ip = ipInt(response.data.ip).toInt()
      return Promise.resolve(ip)
    } catch (error) {
      return Promise.reject(error)
    }
  }
  static async loadParams (payload, body = {}) {
    let url = ''
    if (payload.inquiryToken) {
      url = '/inquiries/get-ext-params/inquiry/' + payload.inquiryToken
    } else {
      url = '/inquiries/get-ext-params/' + payload.formToken
    }
    if (payload.aid) {
      url = url + '/' + payload.aid
    }
    try {
      const response = await api.post(url, body)
      return Promise.resolve(response.data)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default ParamsService
